import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  class: "panel-header",
  "data-qa": "panel-header"
}
const _hoisted_3 = {
  class: "user-info",
  "data-qa": "user-info"
}
const _hoisted_4 = {
  class: "last-login",
  "data-qa": "last-auth-date"
}
const _hoisted_5 = ["data-qa"]
const _hoisted_6 = ["data-qa"]
const _hoisted_7 = { "data-qa": "preferences-title" }
const _hoisted_8 = { class: "panel-body" }
const _hoisted_9 = { class: "panel-body" }
const _hoisted_10 = { class: "panel-footer" }

import { ref, computed, nextTick, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { UseStoreUser } from '@/store/userStore';
import KeycloakService from '@/services/keycloakService';
import { UseClientStore } from '@/store/clientStore';
import { UseStoreAdmin } from '@/store/adminStore';
import AdminLiensUtil from '@/components/AdminLiensUtil.vue';
import type { PreferencesDto, PreferencesLanguage } from '@/types/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderTop',
  props: {
    accessDeniedMode: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

//const searchKeyword = ref('')
const { t } = useI18n();
const userStore = UseStoreUser();
const clientStore = UseClientStore();
const adminStore = UseStoreAdmin();
const currentStep = ref<string>('');
const curPos = ref<string>('right');

const { locale } = useI18n();
const logoCbs = require('@/assets/images/Logo_CBS.svg');

const headerRef = ref<any | null>(null);

onMounted(async () => {
  await nextTick();

  const avatar = headerRef.value?.$el?.querySelector('.cs-avatar');

  const label = t('header.avatarLabel', {
    firstName: userStore.user.firstName,
    lastName: userStore.user.lastName,
  });
  if (avatar) {
    avatar.setAttribute('aria-label', label);
    avatar.removeAttribute('title');
  }
});

function setLanguage(lang: string) {
  locale.value = lang;
}
function cancel(): void {
  if (currentStep.value == 'PREFERENCES') {
    setLanguage(userStore.userInDb.preferences?.language || 'fr');
    values.value.selectValue1 =
      userStore.userInDb.preferences?.language || 'fr';
  }
  if (currentStep.value != 'ADMIN_LINK') closePanel();

  if (currentStep.value == 'ADMIN_LINK') {
    currentStep.value = 'ADMIN';
  }
}
function save(event: MouseEvent): void {
  if (currentStep.value == 'PREFERENCES') {
    const userId = userStore.userInDb.id;
    const preferences: PreferencesDto = {
      language: values.value.selectValue1 as PreferencesLanguage,
    };
    userStore.updatePreferences(userId, preferences);
  }
}

const closePanel = () => {
  currentStep.value = '';
};
const openPanelSecurity = () => {
  currentStep.value = 'SECURITY';
};
const openPanelPreferences = () => {
  currentStep.value = 'PREFERENCES';
};
const openPanelAdmin = () => {
  currentStep.value = 'ADMIN';
};
const openPanelAdminLink = async () => {
  currentStep.value = 'ADMIN_LINK';
  await adminStore.loadAdminLinks();
};
const values = ref({
  selectValue1: userStore.userInDb.preferences?.language || 'fr',
});
const options = ref([
  { label: t('panel.French'), value: 'fr' },
  { label: t('panel.English'), value: 'en' },
  { label: t('panel.Espagnol'), value: 'es' },
]);
const description = computed(() => [
  {
    fields: [
      {
        name: 'selectValue1',
        type: 'select',
        label: t('panel.MyFavoriteLanguage'),
        options: options.value,
      },
    ],
  },
]);
function makeChange(name: string, value: any): void {
  console.log({ [name]: value });
  values.value.selectValue1 = value;
  setLanguage(value);
}

/*const emit = defineEmits<{
  (e: 'update-search', value: string): void
}>()*/
// Display name: firstName + lastName from token/profile, fallback to username if empty
const displayName = computed(() => {
  const full = [userStore.user.firstName, userStore.user.lastName]
    .filter(Boolean)
    .join(' ')
    .trim();
  return full || userStore.user.username || '';
});

const avatarProps = computed(() => ({
  name: displayName.value,
  textToShow: userStore.user.username,
}));

const avatarPanel = computed(() => ({
  name: displayName.value,
  size: 40,
}));

const lastAuthDate = ref(new Date());

const hubList = computed(() =>
  userStore.userApps.map(app => ({
    label: app.displayLabel ?? app.label,
    pictoName: app.pictoName,
    callback: () => {
      window.open(app.link, '_blank');
    },
  }))
);

// Actions du profil utilisateur
function getProfileActions() {
  const showSecurity = false; // or any condition/variable
  const isAdmin =
    (userStore.userRoles as Record<string, { roles?: string[] }>)[
      'hub-back'
    ]?.roles?.includes('hub-admin') ?? false;
  const actions: {
    code: string;
    icon: string;
    callback: () => void;
    text: string;
    dataCyId: string;
  }[] = [];

  if (showSecurity) {
    actions.push({
      code: 'security',
      icon: 'verrouiller',
      callback: openPanelSecurity,
      text: t('srh-ui.topHeader.accountSecurity'),
      dataCyId: 'security',
    });
  }

  actions.push({
    code: 'preferences',
    icon: 'configuration_durable',
    callback: openPanelPreferences,
    text: t('srh-ui.general.preferences'),
    dataCyId: 'preferences',
  });
  if (isAdmin) {
    actions.push({
      code: 'mode Admin',
      icon: 'presence',
      callback: openPanelAdmin,
      text: t('topHeader.menu.modeAdmin'),
      dataCyId: 'mode admin',
    });
  }

  return actions;
}
/*function updatekeyword (value:string){
  console.log(value)
  emit('update-search',value)
}*/

// Déconnexion
function logOffClicked(): void {
  KeycloakService.CallLogout(); // <-- Function is now actually being called
}

// Define the callback function
const notificationCallback = (event: any): void => {
  console.log(event);
};

// Define the notifications array with proper typing
const notifications = ref<{ code: string; callback: (event: any) => void }[]>([
  { code: 'n1', callback: notificationCallback },
  { code: 'n2', callback: notificationCallback },
  { code: 'n3', callback: notificationCallback },
]);

// Other methods
const handleNavigateToScreen = (event: any): void => {
  console.log(event);
};
const formattedLastAuthDate = computed(() => {
  const date = new Date(lastAuthDate.value);
  return (
    date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }) +
    ' ' +
    t('panel.à') +
    ' ' +
    date.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
    })
  );
});

return (_ctx: any,_cache: any) => {
  const _component_cs_top_header = _resolveComponent("cs-top-header")!
  const _component_cs_avatar = _resolveComponent("cs-avatar")!
  const _component_cs_form = _resolveComponent("cs-form")!
  const _component_cs_basic_card = _resolveComponent("cs-basic-card")!
  const _component_cs_button = _resolveComponent("cs-button")!
  const _component_cs_panel = _resolveComponent("cs-panel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_cs_top_header, {
      ref_key: "headerRef",
      ref: headerRef,
      class: "headerTop",
      avatar: avatarProps.value,
      "profile-actions": props.accessDeniedMode ? [] : getProfileActions(),
      "last-auth-date": lastAuthDate.value,
      hub: props.accessDeniedMode ? [] : hubList.value,
      onLogOffClicked: logOffClicked,
      onNavigateToScreen: handleNavigateToScreen,
      "data-qa": "top-header"
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: 
          _unref(clientStore).rcuClient.logo
            ? _unref(clientStore).rcuClient.logo.split('::')[1] || _unref(logoCbs)
            : _unref(logoCbs)
        ,
          alt: "Client Logo",
          class: "logo",
          "data-qa": "company-logo"
        }, null, 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["avatar", "profile-actions", "last-auth-date", "hub"]),
    _createVNode(_component_cs_panel, {
      class: "aside-section custom-offset",
      "is-opened": currentStep.value != '',
      position: curPos.value,
      onClose: closePanel,
      footer: true,
      hasBackButton: false,
      "data-qa": `side-panel-${currentStep.value != ''}`
    }, _createSlots({
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_cs_avatar, _mergeProps({ id: "panelAvatar" }, avatarPanel.value, { "data-qa": "panel-avatar" }), null, 16),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('panel.Lastauthentication')) + " : " + _toDisplayString(formattedLastAuthDate.value), 1),
            _createElementVNode("p", {
              class: "user-name",
              "data-qa": `user-name-${avatarPanel.value.name}`
            }, _toDisplayString(avatarPanel.value.name), 9, _hoisted_5)
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_cs_button, {
            type: "secondary",
            text: 
            currentStep.value.includes('ADMIN') ? _unref(t)('panel.close') : _unref(t)('panel.Cancel')
          ,
            onClick: cancel,
            "data-qa": "cancel-button"
          }, null, 8, ["text"]),
          (!currentStep.value.includes('ADMIN'))
            ? (_openBlock(), _createBlock(_component_cs_button, {
                key: 0,
                icon: "enregistrer",
                type: "primary",
                text: _unref(t)('panel.Save'),
                onClick: save,
                "data-qa": "save-button"
              }, null, 8, ["text"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, [
      (currentStep.value == 'PREFERENCES')
        ? {
            name: "default",
            fn: _withCtx(() => [
              _createElementVNode("div", {
                class: "panel-body",
                "data-qa": `preferences-section-${currentStep.value == 'PREFERENCES'}`
              }, [
                _createElementVNode("h2", _hoisted_7, _toDisplayString(_unref(t)('srh-ui.general.preferences')), 1),
                _createVNode(_component_cs_form, {
                  value: values.value,
                  description: description.value,
                  onChange: makeChange,
                  buttonsDisabled: true,
                  "disabled-focus-on-first-item": true,
                  "data-qa": "preferences-form"
                }, null, 8, ["value", "description"])
              ], 8, _hoisted_6)
            ]),
            key: "0"
          }
        : undefined,
      (currentStep.value == 'ADMIN')
        ? {
            name: "default",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h2", null, _toDisplayString(_unref(t)('topHeader.menu.modeAdmin')), 1),
                _createVNode(_component_cs_basic_card, {
                  class: "basic-card",
                  label: _unref(t)('panel.widgetLiensUtiles'),
                  onClick: openPanelAdminLink,
                  clickable: "true",
                  icon: "deplier_direction_droite"
                }, null, 8, ["label"]),
                false
                  ? (_openBlock(), _createBlock(_component_cs_basic_card, {
                      key: 0,
                      class: "basic-card",
                      label: _unref(t)('panel.widgetVidéo'),
                      onClick: () => {},
                      clickable: "true",
                      icon: "deplier_direction_droite"
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createBlock(_component_cs_basic_card, {
                      key: 1,
                      class: "basic-card",
                      label: _unref(t)('panel.thème'),
                      onClick: () => {},
                      clickable: "true",
                      icon: "deplier_direction_droite"
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            key: "1"
          }
        : undefined,
      (currentStep.value == 'ADMIN_LINK')
        ? {
            name: "default",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(AdminLiensUtil)
              ])
            ]),
            key: "2"
          }
        : undefined
    ]), 1032, ["is-opened", "position", "data-qa"])
  ], 64))
}
}

})